module.exports = __webpack_public_path__ + "static/media/youtube_us.863b9aa8.png";